import React, { useState, useContext } from "react";
import "../../Style/deletestyle.scss";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import { Stack, Box, TextField, Typography, IconButton } from "@mui/material";
import { useMutation } from "@apollo/client";
//Schema
import { AuthContext } from "../../Context/AuthContext";
import { APPROVE_TAKELEAVE_MODIFY, DENIE_TAKELEAVE_MODIFY } from "../../Schema/TakeLeave";

export default function ApproveAndDenyRequestModify({
  open,
  handleClose,
  userLogin,
  editData,
  requestStatus,
  setRefetch,
}) {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const [approveModifyTakeLeave] = useMutation(APPROVE_TAKELEAVE_MODIFY, {
    onCompleted: ({ approveModifyTakeLeave }) => {
      // console.log("approveModifyTakeLeave::", approveModifyTakeLeave);
      setLoading(false);
      if (approveModifyTakeLeave?.success === true) {
        setAlert(true, "success", approveModifyTakeLeave?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", approveModifyTakeLeave?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const [denyModifyTakeLeave] = useMutation(DENIE_TAKELEAVE_MODIFY, {
    onCompleted: ({ denyModifyTakeLeave }) => {
      // console.log(denyModifyTakeLeave);
      setLoading(false);
      if (denyModifyTakeLeave?.success === true) {
        setAlert(true, "success", denyModifyTakeLeave?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", denyModifyTakeLeave?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { setAlert } = useContext(AuthContext);

  const handleSubmit = () => {
    setLoading(true);
    if (requestStatus === "Approve") {
        approveModifyTakeLeave({
        variables: {
          takeLeaveId: editData?._id,
          userId: userLogin?._id,
          message: message,
        },
      });
    } else {
      denyModifyTakeLeave({
        variables: {
          takeLeaveId: editData?._id,
          userId: userLogin?._id,
          message: message,
        },
      });
    }
  };

  return (
    <Dialog open={open} className="approve-container">
      <DialogTitle className="dialog-title">
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">{requestStatus === "Approve" ? "Approve" : "Deny"} Request Modify</Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <CloseIcon className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Stack direction="column" spacing={2}>
          <Typography className="approve-body-text">
            Do you really want to{" "}
            {requestStatus === "Approve" ? "approve" : "deny"}?
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={3}
            size="small"
            placeholder="message for email send"
            onChange={(e) => setMessage(e.target.value)}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Stack direction="row" spacing={4} className="action-container">
          <Button className="btn-cencel" fullWidth onClick={handleClose}>
            Cencel
          </Button>

          {loading === true ? (
            <Button
              className={
                requestStatus === "Approve" ? "btn-approve" : "btn-delete"
              }
              fullWidth
            >
              Loading...
            </Button>
          ) : (
            <Button
              className={
                requestStatus === "Approve" ? "btn-approve" : "btn-delete"
              }
              fullWidth
              onClick={handleSubmit}
            >
              {requestStatus === "Approve" ? "Approve" : "Deny"}
            </Button>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
